import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { makeStyles } from '@material-ui/styles';

import { useMeetings, View } from './MeetingsToolContext';
import ManageMeetings from '../ManageMeetings';
import SchedulingWizard from '../SchedulingWizard';
import MeetingInvitation from '../MeetingInvitation';
import ContactListPage from '../ManageMeetings/ContactListPage';
import ZeroState from '../ManageMeetings/ZeroState';
import { MeetingsToolsParamsAtom, MeetingsToolsParamsType } from '../../../appState/meetings/atoms';
import ErrorBoundaryWrapper from '../../components/ErrorBoundaryWrapper';

const MeetingsToolView: React.FC = () => {
    const { view, openWizard, setView } = useMeetings();
    const classes = useStyles();

    const [meetingsToolsParams, setMeetingsToolsParams] = useAtom(MeetingsToolsParamsAtom);

    useEffect(() => {
        if (meetingsToolsParams.type === MeetingsToolsParamsType.OpenWizard) {
            openWizard({ otherAttendeeId: meetingsToolsParams.otherAttendeeId });
            setMeetingsToolsParams({ type: MeetingsToolsParamsType.Empty });
        }
    }, [meetingsToolsParams]);

    const handleReset = () => {
        setView(View.Manage);
    };

    return (
        <ErrorBoundaryWrapper onReset={handleReset}>
            <div className={classes.meetingsView}>
                {view === View.Manage && <ManageMeetings />}
                {view === View.ZeroState && <ZeroState isBackButtonShow />}
                {view === View.ContactListPage && <ContactListPage />}
                {view === View.SchedulingWizard && <SchedulingWizard />}
                {view === View.MeetingInvitation && <MeetingInvitation />}
            </div>
        </ErrorBoundaryWrapper>
    );
};

const useStyles = makeStyles(
    () => ({
        meetingsView: {
            height: '100%',
            position: 'relative',
        },
    }),
    { classNamePrefix: 'meetings-meeting-tool' }
);

export default MeetingsToolView;
